<c-card *transloco="let t">
    <c-card-body class="px-2">

        <c-row>
          <c-col md="6">
            <h1>{{ t('Mass Notification System') }}</h1>
            <p>{{ t('Use this page to mass send urgent SMS or emails to workers or monitors. You can immediately alert people to critical situations that could affect their personal safety through one platform.') }}</p>
          </c-col>
        <c-col md="6">
        <a href="https://okalone.zendesk.com/hc/en-gb/articles/35353050292113-Sending-Mass-Notifications-to-Workers-and-Monitors" class="btn btn-primary" target="_new"><i class="fa fa-question-circle" aria-hidden="true"></i> {{ t('Help') }}</a>
      </c-col>
        </c-row>

        <c-row>
            <div class="col-sm-12 col-md-6" *ngIf="!sent && formGroup">



              <div *ngIf="!okService.billing.plan.comms_active" class="alert alert-warning" role="alert">
                <i class="fa-solid fa-triangle-exclamation text-danger"></i> 
                @if(okService.billing.plan.account_type == "Pricing2024"){
                  {{ t('To use the Mass Notifications feature you must have the Automated Plan for your account. To set up the Automated Plan please go to your') }}
                }@else{
                  {{ t('To use the Mass Notifications feature you must have the Comms Plan for your account. To set up the Comms Plan please go to your') }}
                }
                <a routerLink="/account/account">{{ t('Account Settings') }}</a>.<br/>
                <i class="fa-solid fa-circle-info text-info"></i> {{ t('Learn more about the Comms Plan') }} <a href="https://www.okaloneworker.com/what-is-the-comms-plan/" target="_new">{{ t('here') }}</a>.
            </div>

                <form class="form-horizontal" [formGroup]="formGroup" cForm (ngSubmit)="submitForm()">


                    <div class="form-group row mb-2">
                        <div class="col-8">
                            <div class="form-floating">
                                <textarea class="form-control"  id="floatingTextarea"   formControlName="content"  maxlength="150" style="max-width:600px;height:80px"
                                [ngClass]="{ 'border-danger': submitted && f['content'].errors }"
                                ></textarea>
                                <label for="floatingTextarea">{{ t('Message to send') }}</label>
                            </div>
                            <div *ngIf="submitted && f['content'].errors" class="invalid-feedback">
                                {{ t('Please enter content here.') }}
                            </div>
                            <p class="fw-light">{{ t('Maximum of 150 characters per content.') }}</p>
                        </div>
                    </div>

                      <div class="form-group row mb-2">
                        <label for="admin" class="col-4 col-form-label text-start text-sm-end">{{ t('Message Type') }}</label>
                        <div class="col-8">
                          <select  class="form-control" id="type" name="type" formControlName="type"
                          [ngClass]="{ 'border-danger': submitted && f['type'].errors }">
                            <option value="">{{ t('Choose message type') }}</option>
                            <option value="email">{{ t('Email') }}</option>
                            <option value="sms">{{ t('SMS') }}</option>
                          </select>
                          <div *ngIf="submitted && f['type'].errors" class="invalid-feedback">
                              {{ t('Please choose email or SMS for the message type.') }}
                          </div>
                        </div>
                      </div>

                        <div class="form-group row mb-2">
                          <label for="admin" class="col-4 col-form-label text-start text-sm-end">{{ t('Send to') }}</label>
                          <div class="col-8">
                            <select  class="form-control" id="who" name="who"   formControlName="who">
                              <option value="workers">{{ t('Workers') }}</option>
                              <option value="monitors">{{ t('Monitors') }}</option>
                            </select>
                          </div>
                        </div>

                        <div class="form-group row mb-2"  *ngIf="okService.groups.length > 0">
                            <label class="col-4 col-form-label text-start text-sm-end">{{ t('Groups') }}</label>
                            <div class="col-8">

                              <ng-select [items]="okService.groups"
                                        bindLabel="name"
                                        bindValue="id"
                                        [multiple]="true"
                                        placeholder="{{ t('Optional groups') }}"
                                        formControlName="groups">
                              </ng-select>
                            </div>
                          </div>

                        <!-- <div class="form-group row mb-2" *ngIf="formGroup.value.who=='workers'">
                          <label for="admin" class="col-4 col-form-label text-start text-sm-end">{{ t('Shift Status') }}</label>
                          <div class="col-8">
                            <select  class="form-control" id="status" name="status"   formControlName="status">
                              <option value="on_shift">{{ t('On Shift Only') }}</option>
                              <option value="all">{{ t('All') }}</option>
                            </select>
                          </div>
                        </div> -->

                        <div class="alert alert-primary" role="alert" *ngIf="alert" [class.alert-success]="alert.type=='success'" [class.alert-danger]="alert.type=='error'">
                            {{alert.content}}
                        </div>


                      <button cButton class="px-4 mb-2 text-white btn-info" type="submit" *ngIf="okService.billing.plan.comms_active">
                        <i class="fa-solid fa-check"></i> {{ t('Send the Message') }}
                      </button>

                </form>

            </div>
        </c-row>

        <c-row>
            <div class="col-sm-12 col-md-6" *ngIf="sent">
                <div class="alert alert-primary" role="alert" *ngIf="alert" [class.alert-success]="alert.type=='success'" [class.alert-danger]="alert.type=='error'">
                    {{alert.content}}
                </div>
                <br/><br/>
                <button cButton class="px-4 mb-2 text-white btn-info" (click)="reset()">
                    <i class="fa-solid fa-refresh"></i> {{ t('Send Another Message') }}
                </button>

            </div>
        </c-row>
    </c-card-body>
  </c-card>
